import React from "react";
import { Card } from "react-bootstrap";
 
const FeedbackMaestro = () => {
    return (
		<>
            <Card>
                <Card.Header>Feedback</Card.Header>
                <Card.Body>
                    <div className="text-center py-5">
                        <h2>Coming Soon</h2>
                        <p className="text-muted mt-3 mb-0">Questa funzionalità sarà disponibile a breve.</p>
                    </div>
                </Card.Body>
            </Card>
        </>
	)
}
export default FeedbackMaestro;
